import React from "react";
import ReactTooltip from "react-tooltip";
import PropTypes from "prop-types";
import CheckBox from "components/CheckBox";
import "./index.scss";

const FarmCheckboxCell = ({ value, selectedFarms, selectFarm }) => (
  <div data-testid="farm-checkbox-cell" className="farm-checkbox-cell">
    <ReactTooltip className="tooltip" effect="solid" />
    <CheckBox
      data-tip="Select Farm"
      data-testid="checkbox"
      defaultChecked={selectedFarms.includes(value)}
      onChange={() => selectFarm(value)}
    />
  </div>
);

FarmCheckboxCell.defaultProps = {
  selectedFarms: [],
};

FarmCheckboxCell.propTypes = {
  value: PropTypes.number.isRequired,
  selectedFarms: PropTypes.arrayOf(PropTypes.number),
  selectFarm: PropTypes.func.isRequired,
};

export default FarmCheckboxCell;
